<template>
  <div class="content">

    <b-container fluid class="mt-4">

      <stats-card title="Traps" type="default" sub-title="All traps" icon="fas fa-map-marker-alt">
        <template slot="actions">
          <a class="dropdown-item" href="javascript:void(0)" @click="showUpdateModal = true">Update many</a>
        </template>

        <template slot="append">

          <base-alert>
            Last 10 traps created displayed here.
          </base-alert>

          <div class="mt-4">
            <entity-picker v-if="sensorData.length > 0"
                :canEdit="true"
                :canSelect="false"
                placeHolder="Start typing something..."
                apiEndpoint="getSensors"
                :selected="sensorData"
                :filters="sensorFilters"
                editPath="/sensors/"
                :tableColumns="tableColumns"
                :tableOptions="tableOptions"
                :cursorData="cursorData"
                :canExport="true"
                rootProp="sensors"
            >
            </entity-picker>
          </div>
        </template>
      </stats-card>
    </b-container>

    <sensors-update-modal :is-open.sync="showUpdateModal" />
  </div>

</template>


<script>
import api from '@/api'
import { tableColumns, tableFilters, tableOptions } from '@/config/SensorTable'

export default {
  components: {
  },
  data() {
    return {
      sensorData: [],
      showCreateModal: false,
      sensorFilters: tableFilters,
      tableColumns: tableColumns,
      tableOptions: tableOptions,
      cursorData: null,
      showUpdateModal: false,
      selectedSensors: []
    }
  },
  created: async function() {
    this.fetchSensors()
  },
  methods: {
    fetchSensors: async function() {
      this.$emit('loading', true);
      const results = await api.getSensors({
        sort: this.tableOptions['default-sort'].prop,
        direction: this.tableOptions['default-sort'].order == 'ascending' ? 'asc' : 'desc',
        limit: this.tableOptions.limit
      })
      // console.log(results)
      this.$emit('loading', false)
      this.sensorData = results.sensors
      this.cursorData = results.cursor
    },
  }
};
</script>
